import { DynamicFieldData, FormField } from "@/common/types";
import { combinedDescription } from "@/common/utils";

export interface TicketForm {
  name?: string;
  email?: string | null;
  subject?: string;
  description?: string;
}

export const getRequestFields = ({
  allFields,
  form,
  issueMsg = "",
  userEmail = "",
  userPhone = ""
}: {
  allFields: FormField[];
  form: TicketForm;
  issueMsg?: string;
  userEmail?: string;
  userPhone?: string;
}): DynamicFieldData["fields"] => {
  const NOT_HANDLED = "title not handled";

  return allFields.map(item => {
    const itemName = (item.name || "").trim().toLowerCase();

    if (itemName === "description" && issueMsg) {
      const description =
        `${form[itemName as keyof TicketForm]}` || NOT_HANDLED;

      const value = combinedDescription(description, issueMsg);

      return {
        key: itemName,
        value,
        id: item.id
      };
    }

    if (itemName === "email" && !form.email) {
      return { id: item.id, key: itemName, value: userEmail };
    }

    return {
      id: item.id,
      key: itemName,
      value:
        itemName === "phone"
          ? userPhone
          : form[itemName as keyof TicketForm] || NOT_HANDLED
    };
  });
};
